import { Directive } from '@angular/core'

import { ThemeComponent } from '@flowx/core-theme'

import { FlxComponentThemeBaseDirective } from './component-theme-base.directive'

import { ComponentType } from '../injectors'

@Directive({
  selector: 'flx-table,flx-table-cell',
  standalone: true,
  hostDirectives: [FlxComponentThemeBaseDirective],
  providers: [
    { provide: ComponentType, useValue: [ThemeComponent.Table, ThemeComponent.TableHeader] },
  ],
})
export class FlxTableThemeDirective {}
